import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StarredItemsService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  getStarredItems(): Observable<any> {
    return this.#http.getData<any>(`${this.baseUrl}/starredItems`, {
      showLoader: true,
      showMessage: false
    });
  }

  addStarred(id: string): Observable<any> {
    return this.#http.postData<any>(
      `${this.baseUrl}/starredItems/${id}`,
      { showLoader: false, showMessage: false },
      ''
    );
  }

  removeStarred(id: string): Observable<any> {
    return this.#http.deleteData<any>(`${this.baseUrl}/starredItems/${id}`, {
      showLoader: false,
      showMessage: false
    });
  }
}
